/* eslint-disable*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Input, Button, Grid, Modal } from '../../components';
import Periodo from '../calculadora-periodos/Periodo';


class ModalCalculadoraPeriodo extends Component {  
  constructor(props) {
    super(props);
    this.state = {
      periodosRgps: { 
        totalAno: '',
        totalMes: '',
        totalDia: '',
        qtdTotalDias: '',
      },
      listaPeriodos: [],
      periodo: { 
        index: 0,
        dataInicio: '',
        dataFim: '',
        totalAno: '',
        totalMes: '',
        totalDia: '',
      },
      totalTempoDescontado: 0,
      totalTempoContribuicaoLiquido: 0,
    };
  }
  
  componentDidMount() {
    this.montaFormulario();
  };

  montaFormulario = () => {
    let { listaPeriodos } = { ...this.state };
    listaPeriodos = this.handleCriarPeriodoApartirDeRequerimentos();
    if(listaPeriodos.length === 0 ) {
      let periodo = {};
      periodo.index = 0;
      periodo[`dataInicio-0`] = '';
      periodo[`dataFim-0`] = '';
      periodo.totalAno = '';
      periodo.totalMes = '';
      periodo.totalDia = '';

      listaPeriodos.push(periodo);
    } 
    listaPeriodos = this.reorganizarIndiceLista(this.ordenarListaPeriodos(listaPeriodos));
    this.setState({ listaPeriodos });
  };
   
  validarRegrasPeriodo = () => {
    let { listaPeriodos } = { ...this.state };
    listaPeriodos.forEach((periodo) => {
      periodo = this.handleCalcularAmd(periodo);
      this.handleCalcularRgps();
    }); 
    this.setState({
      listaPeriodos,
    });
  };

  compararDatasInicio = (a, b) => {
    if (moment(a[`dataInicio-${a.index}`], 'DD/MM/YYYY').toDate() < moment(b[`dataInicio-${b.index}`], 'DD/MM/YYYY').toDate()) {
      return -1;
    }
    if (moment(a[`dataInicio-${a.index}`], 'DD/MM/YYYY').toDate() > moment(b[`dataInicio-${b.index}`], 'DD/MM/YYYY').toDate()) {
      return 1;
    }
    return 0;
  };

  ordenarListaPeriodos = (lista) => {
    return lista.sort(this.compararDatasInicio);
  };

  reorganizarIndiceLista = () => {
    let { listaPeriodos } = { ...this.state };
    let listaIndiceCorrigido = [];
    
    listaPeriodos.forEach((periodo, arrayIndex) => {
      let retorno = {};
      if (periodo.index === arrayIndex) {
        retorno.index = periodo.index;
        retorno[`dataInicio-${arrayIndex}`] = periodo[`dataInicio-${arrayIndex}`];
        retorno[`dataFim-${arrayIndex}`] = periodo[`dataFim-${arrayIndex}`];
        retorno.totalAno= periodo.totalAno;
        retorno.totalMes = periodo.totalMes;
        retorno.totalDia = periodo.totalDia;
      } else {
        retorno.index = arrayIndex;
        retorno[`dataInicio-${arrayIndex}`] = periodo[`dataInicio-${periodo.index}`];
        retorno[`dataFim-${arrayIndex}`] = periodo[`dataFim-${periodo.index}`];
        retorno.totalAno= periodo.totalAno;
        retorno.totalMes = periodo.totalMes;
        retorno.totalDia = periodo.totalDia;
      }
      listaIndiceCorrigido.push(retorno);
    });
    return listaIndiceCorrigido;
  };

  handleCriarPeriodoApartirDeRequerimentos = () => {
    let { listaPeriodos, totalTempoDescontado } = { ...this.state };
    let { requerimentoPeriodos } = { ...this.props.estadoFormulario.requerimento };
    requerimentoPeriodos.forEach((periodo) => {
      let periodoAux = {};
      periodoAux.index = periodo.indice;
      periodoAux[`dataInicio-${periodoAux.index}`] = periodo.dataInicio;
      periodoAux[`dataFim-${periodoAux.index}`] = periodo.dataFim;
      periodoAux.totalAno= '';
      periodoAux.totalMes = '';
      periodoAux.totalDia = '';
  
      listaPeriodos.push(periodoAux);
    });
    this.validarRegrasPeriodo();
    totalTempoDescontado = this.handleCalcularDiasDescontados();
    this.handleCalcularTempoLiquido(totalTempoDescontado);
    return listaPeriodos;
  };

  handleCalcularAmd = (periodo) => {
    const acrescentarDia = 1;
    const acrescentarMesDias = 30;
    const trintaUm = 31;
    const qtdDiasMes = 30;
    const qtdMesesAno = 12;
    const acrescentarAno = 12;
    const reduzirMes = 1;
    const reduzirAno = 1;
    const mesFev = 2;
    const ultimoDiaFevBissexto = 29;
    const ultimoDiaFevNaoBissexto = 28;

    let resultadoDia = 0;
    let resultadoMes = 0;
    let resultadoAno = 0;

    let resultadoQtdMeses = 0;
    let restoDivisaoDia = 0;
    let resultadoQtdAnos = 0;
    let restoDivisaoMes = 0;

    let diaInicio = periodo[`dataInicio-${periodo.index}`].split('/')[0];
    let mesInicio = periodo[`dataInicio-${periodo.index}`].split('/')[1];
    let anoInicio = periodo[`dataInicio-${periodo.index}`].split('/')[2];

    let diaFim = periodo[`dataFim-${periodo.index}`].split('/')[0];
    let mesFim = periodo[`dataFim-${periodo.index}`].split('/')[1];
    let anoFim = periodo[`dataFim-${periodo.index}`].split('/')[2];

   
    if (moment([anoFim]).isLeapYear()) {
      if (Number(mesFim) === mesFev && Number(diaFim) === ultimoDiaFevBissexto) {
        diaFim = Number(diaFim) + 1;
      }   
    } else {
      if (Number(mesFim) === mesFev && Number(diaFim) === ultimoDiaFevNaoBissexto) {
        diaFim = Number(diaFim) + 2;
      }
    }
    
    if (Number(diaFim) < trintaUm) {
      diaFim = Number(diaFim) + acrescentarDia;
      if (Number(diaInicio > diaFim)) {
        diaFim = Number(diaFim) + acrescentarMesDias;
        mesFim = Number(mesFim) - reduzirMes;
      }
    }
    resultadoDia = Number(diaFim - diaInicio);

    resultadoQtdMeses = Math.trunc(resultadoDia / qtdDiasMes);
    restoDivisaoDia = (resultadoDia % qtdDiasMes);
    resultadoDia = restoDivisaoDia;

    if(Number(mesFim < mesInicio)) {
      mesFim = Number(mesFim) + acrescentarAno;
      anoFim = Number(anoFim) - reduzirAno;
    }
    resultadoMes = Number(mesFim - mesInicio);
    resultadoMes += resultadoQtdMeses;

    resultadoQtdAnos = Math.trunc(resultadoMes / qtdMesesAno);
    restoDivisaoMes = (resultadoMes % qtdMesesAno);
    resultadoMes = restoDivisaoMes;  

    resultadoAno = Number(anoFim - anoInicio);
    resultadoAno += resultadoQtdAnos;

    periodo.totalAno = Math.trunc((Number(resultadoAno)));
    periodo.totalMes = Math.trunc((Number(resultadoMes)));
    periodo.totalDia = Math.trunc((Number(resultadoDia)));

    return periodo; 
  };

  handleCalcularRgps = () => {
    let { periodosRgps } = { ...this.state };
    let { listaPeriodos } = { ...this.state };

    let resultadoDia = 0;
    let resultadoMes = 0;
    let resultadoAno = 0;

    let resultadoQtdMeses = 0;
    let restoDivisaoDia = 0;
    let resultadoQtdAnos = 0;
    let restoDivisaoMes = 0;
   
    const acrescentarMesDias = 30;
    const qtdDiasMes = 30;
    const qtdMesesAno = 12; 
    const acrescentarAnoDias = 365

    listaPeriodos.forEach((periodo) => {
      if (periodo.totalDia !== '' && periodo.totalMes !== '' && periodo.totalAno !== '') { 

        resultadoDia += periodo.totalDia;
        resultadoQtdMeses = Math.trunc(resultadoDia / qtdDiasMes);
        restoDivisaoDia = (resultadoDia % qtdDiasMes);
        resultadoDia = restoDivisaoDia;
      
        resultadoMes += periodo.totalMes + resultadoQtdMeses;
        resultadoQtdAnos = Math.trunc(resultadoMes / qtdMesesAno);
        restoDivisaoMes = (resultadoMes % qtdMesesAno);
        resultadoMes = restoDivisaoMes;

        resultadoAno += periodo.totalAno + resultadoQtdAnos;
      }
    });
      periodosRgps.totalDia = resultadoDia;
      periodosRgps.totalMes = resultadoMes;
      periodosRgps.totalAno = resultadoAno;
      periodosRgps.qtdTotalDias = Number((resultadoAno * acrescentarAnoDias) + (resultadoMes * acrescentarMesDias) + resultadoDia);
      
      this.setState({
        periodosRgps: { ...this.state.periodosRgps, periodosRgps },
      });
  };

  handleCalcularDiasDescontados = () => {
    let { requerimentoPeriodos } = { ...this.props.estadoFormulario.requerimento };
    let { totalTempoDescontado } = { ...this.state }; 
    requerimentoPeriodos.forEach((periodo) => {
      totalTempoDescontado += periodo.qtdDiasDesconto;
    });
    this.setState({totalTempoDescontado});
    return totalTempoDescontado;
  };

  handleCalcularTempoLiquido = (tempoDescontado) => {
    let { periodosRgps, totalTempoContribuicaoLiquido } = { ...this.state };
    totalTempoContribuicaoLiquido = periodosRgps.qtdTotalDias - tempoDescontado;
    this.setState({totalTempoContribuicaoLiquido});
  };
  
  modalContent = () => {
    let { listaPeriodos } = { ...this.state };
    let colecao = [];
    listaPeriodos.forEach((periodo) => {
      colecao.push(
        <React.Fragment>
          <Periodo
            state = {this.state}         
            periodo = {periodo}
            listaPeriodos = {this.state.listaPeriodos}
            validarRegras = {this.validarRegrasPeriodo}
            displayButton = {false}
            disabledInputDate = {true}
          />
        </React.Fragment>
      )
      return colecao;
    });
    return (
      <div className='row'> 
        <Grid cols="12 12 12 12">
          <div style={{ maxHeight: '200px', 'overflow-y': 'auto', 'overflow-x': 'hidden' }}>
            {colecao}
          </div>
          <div className='row'>  
            <hr></hr>
          </div>
          <div>
            <p><b>Fórmula do RGPS:</b></p>
            <div className="row">
              <Grid cols="1 1 1 1">
                <Input
                  showMask={false}
                  label="Anos"
                  integer
                  disabled
                  value={this.state.periodosRgps.totalAno}
                />
              </Grid>
              <Grid cols="1 1 1 1">
                <Input
                  showMask={false}
                  label="Meses"
                  integer
                  disabled
                  value={this.state.periodosRgps.totalMes}
                />
              </Grid>
              <Grid cols="1 1 1 1">
                <Input
                  showMask={false}
                  label="Dia"
                  integer
                  disabled
                  value={this.state.periodosRgps.totalDia}
                />
              </Grid>
              <Grid cols="1 1 1 1">
                <Input disabled value="|" style={{ borderBottom: 'none', 'text-align': 'center' }} />
              </Grid>
              <Grid cols="2 2 2 2">
                <Input
                  showMask={false}
                  label="Dias"
                  disabled
                  value={this.state.periodosRgps.qtdTotalDias}
                />
              </Grid>
              <Grid cols="3 3 3 3">
                <Input
                  showMask={false}
                  label="Total Tempo Descontado"
                  disabled
                  value={this.state.totalTempoDescontado}
                />
              </Grid>    
              <Grid cols="3 3 3 3">
                <Input
                  showMask={false}
                  label="Tempo Contribuição Líquido"
                  disabled
                  value={this.state.totalTempoContribuicaoLiquido !== 0 ? this.state.totalTempoContribuicaoLiquido : ''}
                />
              </Grid>
            </div>
          </div>
        </Grid>
      </div>     
    )
  };

  handleClose = () => {
    this.setState(this.props.handleModal('showModalCalculadoraPeriodo'));
  };

  modalFooter = () => {
    return (
      <React.Fragment>
        <div className="right">
          <Button
            title="Cancelar"
            onClick={this.handleClose}
            hint="Cancelar"
          />
        </div>
      </React.Fragment>
    )
  };

  render() {
    return ( 
      <Modal
        {...this.props}
        conteudomodal={this.modalContent()}
        conteudofooter={this.modalFooter()}
        onHide={this.handleClose}
        showModal={this.props.showModal}
        size="lg"
        title="Calculadora de Períodos"
        hint="Calculadora de Períodos"
      />
    )   
  }
}

ModalCalculadoraPeriodo.propTypes = { 
  handleModal: PropTypes.func.isRequired,
  showModal: PropTypes.func,
  estadoFormulario: PropTypes.objectOf(PropTypes.object).isRequired,
};

export default ModalCalculadoraPeriodo;



// WEBPACK FOOTER //
// ./src/pages/requerimentos/ModalCalculadoraPeriodo.jsx